import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { EnumTypeNotification } from 'src/app/enumeration/EnumTypeNotification';
import { Notification } from 'src/app/models/Notification';


export const SnackbarTypes = {
    default: 'login-snackbarr',
    success: 'login-snackbar',
    error: 'login-snackbar'
};

@Injectable({
    providedIn: 'root'
})
export class SidebarService {
    public $NotifNonLu: BehaviorSubject<number> = new BehaviorSubject(0);
    notifications: Notification[] = [];

    constructor(
       
        public snackBar: MatSnackBar,
    
    ) {}

    public get NotifNonLu(): number {
        return this.$NotifNonLu.getValue();
    }
    public set NotifNonLu(i: number) {
        this.$NotifNonLu.next(i);
    }

    

    addNewNotification(type: string, message: string, detail: string, snackbar: boolean, exception: boolean): void {
        const notif: Notification = {
            time: Date.now(),
            type: type,
            message: message,
            detail: detail,
            hideDetail: false,
            snackbar: snackbar,
            exception: exception
        };
        this.notifications.unshift(notif);
        //incrementation du nombre de notifications nonLu
        this.NotifNonLu++;

        if (snackbar) {
            switch (type) {
                case EnumTypeNotification.ERREUR:
                    this.snackbar(message, SnackbarTypes.error,3000);
                    break;
                case EnumTypeNotification.INFO:
                    this.snackbar(message, SnackbarTypes.default,1200);
                    break;
                case EnumTypeNotification.SUCCESS:
                    this.snackbar(message, SnackbarTypes.success,3000);
                    break;
                default:
                    break;
            }
        }
    }

    //TODO az
    

    public snackbar(message: string, snackbarType = SnackbarTypes.default, duration: number): void {
        
                this.snackBar.open(message, 'Quitter', {
                    duration: duration,
                    panelClass: ['green-snackbar', 'login-snackbar'],
                    horizontalPosition: 'center'
                });
            
    }

}
